import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { IonInfiniteScroll, ModalController, Platform } from '@ionic/angular';
import { Article } from 'src/app/_interfaces/article';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { ArticleService } from 'src/app/_provider/article.service';
import { DarkmodeService } from 'src/app/_provider/darkmode.service';
import { FeedbackService, MsgType } from 'src/app/_provider/feedback.service';
import { ArticleEditComponent } from 'src/app/_template/ticket-more/ticket-detail-assets/article-edit/article-edit.component';

@Component({
  selector: 'app-article',
  templateUrl: './article.page.html',
  styleUrls: ['./article.page.scss'],
})
export class ArticlePage implements OnInit {

  //#region Properties
  public searchText: string = ""
  public articles: Article[] = []
  private offset: number = 0
  private limit: number = 15
  public loading: boolean = true
  public loadingCount = new Array(12)
  @ViewChild(IonInfiniteScroll, {static: false}) infinityScroll: IonInfiniteScroll
  @ViewChild("search", {static: false}) searchElement: ElementRef
  //#endregion

  //#region Constructor and NgInit
  constructor(
    private articleSrv: ArticleService,
    private modalCtrl: ModalController,
    public darkmode: DarkmodeService,
    public platform: Platform,
    private feedback: FeedbackService
  ) { }

  async ngOnInit() {
    await this.getArticles()
  }

  ionViewDidEnter(){
    setTimeout(() => this.searchElement.nativeElement.focus(), 100);
  }
  //#endregion

  //#region Methods

  public async getArticles(event?: any){
    const result: HttpFunctionResult<Article[]> = await this.articleSrv.getArticles(this.searchText, this.limit, this.offset)
    this.loading = false
    if(!result.success) return
    this.articles = this.articles.concat(result.data)
    if(event && result.data.length == 0) event.target.disable = true
  }

  private keyUptimeout: any
  public searchKeyUp(event: {key: string}){
    clearTimeout(this.keyUptimeout)
    if(event.key == "Enter"){
      if(this.articles.length == 1) this.close(this.articles[0])
    }else{
      this.loading = true
      this.keyUptimeout = setTimeout(async () => {
        this.resetInfinite()
        await this.getArticles()
      }, 300); 
    }
  }

  public async close(article: Article = null){

    if(!article) {
      await this.feedback.hideKeyboardOnIOS()
      return await this.modalCtrl.dismiss()
    } 

    const result: HttpFunctionResult<Article> = await this.feedback.showModal<Article>({
      id: "articleEdit",
      component: ArticleEditComponent,
      componentProps: {article: {...article, serialNumbers: [], quantity: 1}}
    })

    if(!result.success) return
    await this.feedback.hideKeyboardOnIOS()
    await this.modalCtrl.dismiss(result.data, null, "articleSelect")
    
  }

  public async infiniteTriggered(event: any){
    this.offset += this.limit
    await this.getArticles()
    event.target.complete();
  }

  private resetInfinite(){
    this.articles = []
    if(this.infinityScroll) this.infinityScroll.disabled = false
    this.offset = 0
  }

  public formatMoney(value: number): string{
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR"
    }).format(value)
  }

  public async scanArticleNumber(){
    const result: HttpFunctionResult<string> = await this.feedback.getQRCodeData()
    if(!result.data) return

    this.searchText = result.data
    this.searchElement.nativeElement.blur()
    
    this.resetInfinite()
    this.loading = true
    await this.getArticles() 

    if(this.articles.length == 1) this.close(this.articles[0])

  } 

  //#endregion


}
